<template>
  <div>
    <div class="banner innerpageBanner"><div class="container"><div class="caption"><div>
      <h1>评分制度介绍</h1></div></div></div>
      <img src="https://image.insideburgundy.cn/insideburgundy/20190523/9da9b29c4609476db91febe13b41e306.png" class="cover-image"></div>

    <div class="container">
        <searchBox/>
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
          <span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Jasper Morris Inside Burgundy."
              href="#/"
              class="home"
            >
              <span property="name">首页</span>
            </a>
            <meta property="position" content="1">
          </span> /
          <span property="itemListElement" typeof="ListItem">
            <span property="name">评分制度介绍</span>
            <meta property="position" content="2">
          </span>
        </div>
      </div>
    </div>
    <section class="innerPage">
      <!-- Search -->

      <!-- end-->

      <div class="container">
        <rightMenu title="分类"   :menudata='rightListdata' @OnClick='rightClick'/>

        <div class="leftCol tastingIntro">
          <p>Inside Burgundy网站使用以下评分方式对一款葡萄酒做出评价</p>
          <p>&nbsp;</p>
          <p><h3>百分制</h3></p>
          <p>国际上大多数葡萄酒出版物都在使用百分制，这种方式在波尔多或其它产区可能更奏效，但在勃艮第却不尽然。和波尔多每家酒庄只出产一款正牌酒的情况不同，勃艮第每家酒庄都有一系列酒款，级别从特级园、一级园、村级园到大区级不等。</p>
          <p>在某些情况下，一家酒庄的大区级可能比同一家酒庄的村级表现要好，但这种情况极为少有。所以我们需要一些另外的机制，让我们可以看清一款酒在这个产区所有同级别酒款中的表现，因此就有了五星制评分。</p>
          <p>&nbsp;</p>
          <p><h3>五星级</h3></p>
          <p>
            <img
              class="alignnone size-full wp-image-1111"
              src="https://www.insideburgundy.com/wp-content/uploads/2018/09/5stars.jpg"
              alt
              width="97"
              height="40"
            >五星的涵义是：绝世佳酿。五星级的酒款所占全部酒评的比例很少，不足我们在一年当中品鉴酒款的10%。一款大区级的勃艮第达到89、90分就可以获此殊荣，而一款Puligny-Montrachet一级园Les Pucelles的葡萄酒则需要达到96分以上才可以获得同样的评级。
          </p>
          <p>
            <img
              class="alignnone size-full wp-image-1116"
              src="https://www.insideburgundy.com/wp-content/uploads/2018/09/4stars.jpg"
              alt
              width="97"
              height="40"
            >四星的涵义是：出类拔萃。所有获得四星的酒款都值得酒庄特别为之感到骄傲。
          </p>
          <p>
            <img
              class="alignnone size-full wp-image-1115"
              src="https://www.insideburgundy.com/wp-content/uploads/2018/09/3stars.jpg"
              alt
              width="97"
              height="40"
            >三星的涵义是：品质优异，符合预期，或超出预期。常常意味着酒庄在某个特定年份有不俗的表现，三星级及三星以上的葡萄酒都属于“推荐购买”的范畴。
          </p>
          <p>
            <img
              class="alignnone size-full wp-image-1114"
              src="https://www.insideburgundy.com/wp-content/uploads/2018/09/2stars.jpg"
              alt
              width="97"
              height="40"
            >二星的涵义：品质良好。尽管二星听上去像形容品质平庸的葡萄酒，但实际上它指的是那些中等稍稍偏上那部分的葡萄酒。简言之，它用来描述一款不错的酒。
          </p>
          <p>
            <img
              class="alignnone size-full wp-image-1113"
              src="https://www.insideburgundy.com/wp-content/uploads/2018/09/1stars.jpg"
              alt
              width="97"
              height="40"
            >一星的涵义：中规中矩。或者说是低于预期的一部分酒。我们希望这样的酒款占比最少。实际上大多数有品酒笔记的酒都是我们初步筛选过的。如果一款酒连一星都没有，那说明它是一款有缺陷的酒。
          </p>
          <div class="gridBoxes two small">
            <ul>
              <li>
                <div class="content">
                  <div class="img">
                    <img
                      src="https://image.insideburgundy.cn/insideburgundy/20190523/1efbe93b268849deb2c51236bd52c86c.png"
                      alt="An Introduction to Tasting Reports"
                      class="cover-image"
                    >
                  </div>
                  <div class="discription">
                    <h6>品鉴报告介绍</h6>
                    <p>品鉴报告的几种常见形式包括：桶边品鉴、Burgfest、1020品鉴，风土垂直、平行品鉴，点击这里了解更多</p>
                  </div>
                  <a href="#/Appraisalreport" target class="readmore">阅读更多</a>
                </div>
              </li>

              <li>
                <div class="content">
                  <div class="img">
                    <img
                      src="https://image.insideburgundy.cn/insideburgundy/20190527/e17befa3168d49449fb9d724b7e90d53.png"
                      alt="Tasting Reports"
                      class="cover-image"
                    >
                  </div>
                  <div class="discription">
                    <h6>品鉴报告</h6>
                    <p>很多酒评来自我们的年份报告、葡萄园及酒庄主题品鉴。您可以在下方各版块中进行查看。</p>
                  </div>
                  <a
                    href="#/Appraisalreport"
                    target
                    class="readmore"
                  >阅读更多</a>
                </div>
              </li>
            </ul>
            <!-- Top 3 blocks -->
          </div>

          <div class="recent_posts_grid">
            <div id="ajax_frame">
              <div id="ajax_content">
                <div class="gridBoxes three small">
                  <h2>最新报告</h2>

                  <reports    @totalInit='totalChange' :pageNo="pages.pageNo"/>

                </div>
                <!-- page -->
                <pagination  :pageNo='pages.pageNo' :total='pages.total' @pageChange="pageChange"/>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import searchBox from "../template/search";
import pagination from '../template/pagiation';
import rightMenu from '../template/rightMenu';
import reports from '../template/reports'
import ajax from "../ajax";
export default {
  data() {
    return {
      latestList: [],
      pages:{
        total:0,
        pageNo:0
      },
      rightListdata:{}
    };
  },
  components: {
    searchBox,
    pagination,
    rightMenu,
    reports
  },
  created() {
     this.getRightdata()
  },
  methods: {
    getRightdata(){
      ajax.getReportCategories().then(res=>{
        this.rightListdata = res.data
      })
    },
    rightClick(data){
      if(!data.child&&data.id)
      this.$router.push({path:'/Qualification',query:{id:data.id}})
    },
    pageChange(n){
      this.pages.pageNo = n
    },
    totalChange(n){
      this.pages.total = n
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Introductionpage.vue